<template>
  <article class="contact-card">
    <section class="contact-card__section" >
      <div class="avatar" />
      <section>
        <div class="contact-card__text-placeholder contact-card__text-placeholder--medium contact-card__text-placeholder--tall" />
        <div class="contact-card__text-placeholder contact-card__text-placeholder--xlong"  />
      </section>
    </section>
    <section class="contact-card__section_info">
      <article>
        <div class="contact-card__text-placeholder contact-card__text-placeholder--short"/>
        <div class="contact-card__text-placeholder contact-card__text-placeholder--long" />
      </article>
      <article>
        <div class="contact-card__text-placeholder contact-card__text-placeholder--short" />
        <div class="contact-card__text-placeholder contact-card__text-placeholder--medium" />
      </article>
    </section>
  </article>
</template>
<script>
export default {
  name: 'ContactCardPlaceholder'
}
</script>
<style scoped lang="scss">
  .avatar {
    width: 60px;
    height: 60px;
    border-radius: 30px;
    background-color: $disabledBackground;
  }
  .contact-card {
    display: inline-flex;
    flex-direction: column;
    width: 100%;
    border: 1px solid $mediumLightGrey;
    border-radius: 4px;
    padding: 32px 50px;

    &__section {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      & > *:not(:last-child) {
        margin-right: 40px;
      }
      &_info{
        flex-direction: column;
        article {
          margin-top: 16px;
        }
      }

    }
    &__text-placeholder {
      background-color: $disabledBackground;
      height: 20px;
      margin-bottom: 10px;
      &--short {
        width: 75px;
        margin-bottom: 16px;
      }
      &--medium {
        width: 172px;
      }
      &--long {
        width: 252px;
      }
      &--xlong {
        width: 320px;
      }
      &--tall {
        height: 24px;
      }
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
</style>
